import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { ContactUpdateRequestDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useUserContext } from '@/contexts/userContext/User.context.ts';

type Req = {
  contactId: number;
  dto: ContactUpdateRequestDto;
};

type Return = {
  isUpdatingContact: boolean;
  updateContact: (req: Req) => Promise<void>;
};

export const useUpdateContact = (): Return => {
  const { contactsApi } = useApiClient();
  const { userId } = useUserContext();

  const { isPending, mutateAsync } = useMutation<void, AxiosError, Req>({
    mutationFn: async req => {
      await contactsApi.updateContact(userId, req.contactId, req.dto);
    },
    mutationKey: [QueryKeyEnum.CONTACTS.UPDATE],
  });

  return {
    isUpdatingContact: isPending,
    updateContact: mutateAsync,
  };
};
